import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import NotFound from "../pages/not-found";
import Home from "../pages/home";
import SearchPage from "../pages/search";
import DetailsPage from "../pages/hotelDetails/hotelDetails";
import GalleryPage from "../pages/Gallery/Gallery";
import RoomDetailPage from "../pages/RoomDetails/RoomDetails";
import UserDashborad from "../pages/UserDashboard/UserDashboard";
import FAQScreen from "../pages/FAQs/FAQScreen";
import BookingTabContent from "../components/sections/UserTabContent/BookingTabContent";
import FavoriteTabContent from "../components/sections/UserTabContent/FavoriteTabsContent";
import SettingsTabContent from "../components/sections/UserTabContent/SettingsTabContent";
import AccountTabContent from "../components/sections/UserTabContent/AccountTabContent";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import MapPage from "../pages/Map";
import AboutUs from "../pages/AboutUs";
import Press from "../pages/Press";
import Vacancies from "../pages/Vacancies";
import AuthComponent from "../pages/Auth";
import TermsConditions from "../pages/TermsConditions/TermsCondition";
import BlankPage from "../pages/Blank/BlankPage";
import MapOffers from "../pages/MapOffers";
import CookiePolicy from "../pages/CookiePrivacy/CookiePolicy";
import { useNavigate } from "react-router-dom";
import { getRequestAPIState, setResetHomePageToDefault } from "../redux/slices/requestSlice";
import { useSelector, useDispatch } from "react-redux";
import { resetChatsInStore, setIsNormalFlow } from "../redux/slices/chatBotSlice";
import { resetChatGPTOffers, resetAppConfig } from "../redux/slices/appconfigSlice";
import { isDetailSessionLive } from "../utils/detailUrl";

// Owns both the package share URL and the package detail URL, because they are
// the same page at two different addresses.
//
//   /link, no live detail session -> a pasted share link. Home decodes ?data=,
//       runs SearchOnlyListing and routes on to /hotel/query (unchanged flow).
//   /link, live detail session    -> the detail page swapped the address bar for
//       the share URL. Keep rendering it; that URL is display-only.
//   /hotel/:query                 -> always the detail page.
//
// The session flag is in memory on purpose: a pasted link always starts a fresh
// JS context, so "live" means this session already built the page. Both routes
// share this one component so that React reconciles the detail page in place if
// the router ever flips between them, instead of unmounting and refetching.
const PackageRoute = () => {
    const { pathname } = useLocation();
    return pathname === "/link" && !isDetailSessionLive() ? <Home /> : <DetailsPage />;
};

function AppRoutes() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { resetHomePage } = useSelector(getRequestAPIState);

    useEffect(() => {
        if (resetHomePage) {
            // Navigate to home without reloading
            navigate('/', { replace: true });

            // Reset chat-related redux state so ChatWizard can reinitialize
            dispatch(resetChatsInStore());
            dispatch(resetChatGPTOffers());
            dispatch(resetAppConfig());
            dispatch(setIsNormalFlow(true));

            // Notify any mounted components (like ChatWizard) to run their local reset logic
            try {
                window.dispatchEvent(new Event('app:resetHomePage'));
            } catch (e) {
                // ignore
            }

            // Clear the flag in request slice
            dispatch(setResetHomePageToDefault());
        }
    }, [resetHomePage]);

    const appRoutes = [
        { path: "/", element: <Home /> },
        // Web-based package share links land here. Home decodes the embedded
        // package from ?data= (see src/pages/home/index.js).
        { path: "/link", element: <PackageRoute /> },
        { path: "/auth", element: <AuthComponent /> },
        { path: "/search/:guid/:query", element: <SearchPage /> },
        { path: "/hotel/:query", element: <PackageRoute /> },
        { path: "/hotel/:hotelId/map/:type", element: <MapPage /> },
        { path: "/map/:guid/offers/:prevRoute/:page", element: <MapOffers /> },
        { path: "/gallery/:hotelId/:type", element: <GalleryPage /> },
        { path: "/room-detail/:query", element: <RoomDetailPage /> },
        { path: "/me", element: <UserDashborad /> },
        { path: "/faqs", element: <FAQScreen /> },
        { path: "/privacy-policy/:query", element: <PrivacyPolicy /> },
        { path: "/terms-conditions", element: <TermsConditions /> },
        { path: "/about-us", element: <AboutUs /> },
        { path: "/press", element: <Press /> },
        { path: "/vacancies", element: <Vacancies /> },
        { path: "/cookie_policy", element: <CookiePolicy /> },
        { path: "/fetching", element: <BlankPage /> },
        { path: "*", element: <NotFound /> },
    ];

    return (
        // <Router>
        <Routes>
            {appRoutes.map((route, index) => {
                return (
                    <Route key={index} element={route.element} path={route.path} exact>
                        {route.path === "/me" && (
                            <>
                                <Route path={"bookings"} element={<BookingTabContent />} />
                                <Route path={"favorites"} element={<FavoriteTabContent />} />
                                <Route path={"settings"} element={<SettingsTabContent />} />
                                <Route path={"account"} element={<AccountTabContent />} />
                            </>
                        )}
                    </Route>
                );
            })}
        </Routes>
        // </Router>
    );
}

export default AppRoutes;
